<div class="layer" *ngIf="showSpinner">
  <div class="container-logo">
    <img src="../../../../assets/spinner.gif" class="logo" alt="spinner" />
  </div>
</div>